import { connect } from 'react-redux';

import { setAccessibilityValue } from '@store/actions/ux';
import Accessibility from './accessiblity';

const mapStateToProps = state => ({
  filters: state.ux.accessibilities,
});

const mapDispatchToProps = dispatch => ({
  toggleAccessiblity: (target, value) => {
    dispatch(setAccessibilityValue(target, value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Accessibility);
